module.exports = __webpack_public_path__ + "books.svg?e0852ad838113f8b22b99711d4cd4a3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/books.svg
// module id = 118
// module chunks = 0